/**
 * Created by Ning Jiang on 2021-07-02.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {Translation} from "../../core/utils/Translation";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIExternalApiEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIExternalApi";
import {EntryButton} from "./EntryButton";
import {TombstoneRip} from "../TombstoneRip";
import {FullScreenSmoke} from "../view/FullScreenSmoke";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";
import {ShootingController} from "../view/ShootingController";
import {TombstoneRipBackground} from "../view/TombstoneRipBackground";

export class TombstoneRipEntryView extends PIXI.Container implements StageLayer {

    private _questions = [
        [
            "How do you expect your day in Tombstone to be?",
            "Good",
            "Bad",
            "Ugly"
        ],
        [
            "Almost all get killed fast in Tombstone - Do you really wanna risk it when you can play fruit slots?",
            "Fruit me up",
            "I’m up for it"
        ],
        [
            "How you wanna die in Tombstone?",
            "Boots off",
            "Boots on"
        ],
        [
            "Tombstone will kill you like a dog! Is that what you want?",
            "Get me out of here",
            "I think so",
            "I eat dog food"
        ],
        [
            "How do you take your tobacco?",
            "Eyeball it",
            "Chew it",
            "Eat it"
        ],
        [
            "What is your relationship with Tombstones pigs?",
            "They eat me",
            "First cousin",
            "I eat them"
        ],
        [
            "What ammo works best in Tombstone?",
            ".44 caliber",
            ".45 caliber",
            "12 gauge"
        ]
    ];

    private _questionStyle:PIXI.TextStyle = new PIXI.TextStyle({
        align : "center",
        fill : "#aaaaaa",
        fontFamily : "Vollkorn",
        textBaseline : "middle",
        fontSize : 30,
        lineHeight : 44,
        letterSpacing : 2,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BLACK,
        wordWrap : true,
        wordWrapWidth : 450,
        breakWords : true,
        dropShadow : true,
        dropShadowColor : "#000000",
        dropShadowDistance : 15,
        dropShadowAngle : Math.PI / 2,
        dropShadowBlur : 5,
    });
    private _questionFontSize:number = 30;
    private _questionLineHeight:number = 44;

    private _buttonStyle:PIXI.TextStyle = new PIXI.TextStyle({
        align : "center",
        fill : "#aaaaaa",
        // fillGradientStops: [0.6],
        fontFamily : "Vollkorn",
        textBaseline : "middle",
        fontSize : 28,
        lineHeight : 36,
        letterSpacing : 2,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BLACK,
        wordWrap : true,
        wordWrapWidth : 206,
        breakWords : true,
        dropShadow : true,
        dropShadowColor : "#000000",
        dropShadowDistance : 20,
        dropShadowAngle : Math.PI / 2,
        dropShadowBlur : 5,
    });

    private _smokeHolder:PIXI.Container;
    private _questionText:PIXI.Text;
    private _goodButton:EntryButton;
    private _badButton:EntryButton;
    private _uglyButton:EntryButton;
    private _xRipContainer:PIXI.Container;
    private _red:PIXI.Graphics;

    private _startIntroCallback:(value:any) => void;
    private _completed:boolean = false;
    private _lastQuestionId:number = -1;

    private _positions2:number[] = [180, 540];
    private _positions3:number[] = [112, 360, 608];

    constructor() {
        super();

        const bg = new PIXI.Sprite(ImgLoader.getImgTexture("entryBg"));
        bg.anchor.set(0.5);
        bg.position.set(360, 360);
        this.addChild(bg);

        this._smokeHolder = new PIXI.Container();
        this._smokeHolder.position.set(360, 360);
        this.addChild(this._smokeHolder);

        const entryBoard = new PIXI.Sprite(ImgLoader.getImgTexture("entryBoard"));
        entryBoard.anchor.set(0.5);
        entryBoard.position.set(344, 198);
        this.addChild(entryBoard);

        this._questionText = new PIXI.Text("", this._questionStyle);
        this._questionText.anchor.set(0.5);
        this._questionText.position.set(360, 366);
        this._questionText.scale.y = 0.8;
        this.addChild(this._questionText);

        const chooseText = new PIXI.Text(Translation.translate("Choose the correct answer to enter the game!").toLocaleUpperCase(), {
            fill : 0x111111,
            fontFamily : OpenSans.FAMILY,
            wordWrap : false,
            fontWeight : FontWeight.BOLD,
            fontSize : 22
        });
        chooseText.anchor.set(0.5);
        chooseText.position.set(360, 580);
        this.addChild(chooseText);
        while(chooseText.height > 680) {
            chooseText.style.fontSize--;
            chooseText.style.lineHeight--;
        }

        this._xRipContainer = new PIXI.Container();
        this.addChild(this._xRipContainer);
        const xRipText = new PIXI.Text(Translation.translate("NO WIN BELOW BET"), {
            fill : 0xbbbbbb,
            fontFamily : OpenSans.FAMILY,
            wordWrap : true,
            wordWrapWidth : 650,
            breakWords : true,
            fontWeight : FontWeight.BOLD,
            fontSize : 18
        });
        xRipText.anchor.set(1, 0.5);
        this._xRipContainer.addChild(xRipText);

        const xRipLogo = new PIXI.Sprite(ImgLoader.getImgTexture("xRipLogo"));
        xRipLogo.anchor.set(1, 0.5);
        xRipLogo.scale.set(0.5);
        xRipLogo.position.set(-xRipText.width - 4, 0);
        this._xRipContainer.addChild(xRipLogo);

        this._uglyButton = this.createButton();
        this._uglyButton.addClickCallback(() => {
            this.disableAll();
            this._uglyButton.setColor(0x587737);
            TombstoneRipSound.playGunShot(ShootingController.GUN_SHOTGUN);
            gsap.to(this, {duration : 0.1, onComplete : () => this.startIntro()});
        });

        this._badButton = this.createButton();
        this._badButton.addClickCallback(() => {
            this.disableAll();
            this._badButton.setColor(0xb91d2f);
            this.refreshQuestion();
        });

        this._goodButton = this.createButton();
        this._goodButton.addClickCallback(() => {
            this.disableAll();
            this._goodButton.setColor(0xb91d2f);
            this.refreshQuestion();
        });

        TombstoneRip.fullScreenSmoke = new FullScreenSmoke(ImgLoader.getImgTexture("smoke"));

        this.getQuestion();
    }

    private getQuestion():void {
        let questionId = this.getRandomQuestionId();
        while(questionId === this._lastQuestionId) {
            questionId = this.getRandomQuestionId();
        }
        this._lastQuestionId = questionId;
        const question = this._questions[questionId];
        const shuffle = questionId != 0;
        // const question = this._questions[2];

        this._questionText.text = Translation.translate(question[0]).toLocaleUpperCase();
        this._questionText.style.fontSize = this._questionFontSize;
        this._questionText.style.lineHeight = this._questionLineHeight;
        while(this._questionText.height > 120) {
            this._questionText.style.fontSize--;
            this._questionText.style.lineHeight--;
        }

        const positions = question.length > 3 ? this._positions3.concat() : this._positions2.concat();
        this._uglyButton.setText(Translation.translate(question[question.length - 1]).toLocaleUpperCase());
        this._badButton.setText(Translation.translate(question[question.length - 2]).toLocaleUpperCase());
        this._uglyButton.enable(true);
        this._badButton.enable(true);
        if(question.length > 3) {
            this._goodButton.setText(Translation.translate(question[question.length - 3]).toLocaleUpperCase());
            this._goodButton.visible = true;
            this._goodButton.enable(true);
            this._goodButton.x = this.getButtonPosition(positions, shuffle);
            this._badButton.x = this.getButtonPosition(positions, shuffle);
            this._uglyButton.x = this.getButtonPosition(positions, shuffle);
        } else {
            this._goodButton.visible = false;
            this._goodButton.enable(false);
            this._badButton.x = this.getButtonPosition(positions, shuffle);
            this._uglyButton.x = this.getButtonPosition(positions, shuffle);
        }
    }

    private getRandomQuestionId():number {
        return MathHelper.clamp(Math.round(Math.random() * this._questions.length), 0, this._questions.length - 1)
    }

    private getButtonPosition(positions:number[], shuffle:boolean):number {
        if(shuffle) {
            let randomId = MathHelper.clamp(Math.round(Math.random() * positions.length), 0, positions.length - 1);
            return positions.splice(randomId, 1)[0];
        } else {
            return positions.splice(0, 1)[0];
        }
    }

    private createButton():EntryButton {
        const button = new EntryButton(this._buttonStyle);
        button.enable(false);
        button.y = 506;
        this.addChild(button);

        return button;
    }

    private disableAll():void {
        this._goodButton.enable(false);
        this._badButton.enable(false);
        this._uglyButton.enable(false);
    }

    private refreshQuestion():void {
        TombstoneRipSound.playScream();
        if(!this._red) {
            this._red = new PIXI.Graphics();
            this._red.beginFill(0x380000, 1);
            this._red.drawRect(-840, -840, 1680, 1680);
            this._red.endFill();
            this._red.position.set(360, 360);
            this._red.alpha = 0;
            this.addChild(this._red);
        }
        TombstoneRipBackground.shakeStageOnce(0.8, 0.5);
        const tl = gsap.timeline();
        tl.to(this._red, {duration : 0.1, alpha : 0.6})
            .to(this._red, {duration : 0.3, alpha : 0});
        tl.add(gsap.to(this, {duration : 0.3, onComplete : () => this.getQuestion()}), 0);
    }

    private startIntro():void {
        this._completed = true;
        TombstoneRip.fullScreenSmoke.stopSmoke();
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration : 0.2, alpha : 0}));
        tl.add(() => {NolimitApplication.removeLayer("ENTRY")});
        if(this._startIntroCallback) {
            this._startIntroCallback(undefined);
        }
    }

    public show():void {
        // TODO: this.onOrientationChanged();
        this.onResize();
        NolimitApplication.addLayer("ENTRY", this);
        TombstoneRip.fullScreenSmoke.playSmoke(this._smokeHolder);
    }

    public complete():Promise<any> {
        if(this._completed) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            this._startIntroCallback = resolve;
        });
    }

    public onOrientationChanged() {
        TombstoneRip.fullScreenSmoke.onResize();
    }

    public onResize() {
        this._xRipContainer.position.set(
            NolimitApplication.screenBounds.right - 20,
            NolimitApplication.isLandscape ? 675 : (NolimitApplication.screenBounds.bottom - 45)
        );
    }
}